module.exports = __webpack_public_path__ + "static/media/hotspot-active-v2.095cd97e.png";